import { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const scrollPositions = useRef({});
  const prevPath = useRef(pathname);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Fallback za mobilne browsere
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    if (prevPath.current === '/korpa' && pathname === '/meni') {
      const savedPosition = scrollPositions.current['/meni'];
      if (savedPosition) {
        setTimeout(() => {
          window.scrollTo(0, savedPosition);
        }, 100);
      }
    } else {
      if (prevPath.current === '/meni') {
        scrollPositions.current['/meni'] = window.scrollY;
      }
      // Timeout da sačeka renderovanje nove stranice
      requestAnimationFrame(() => {
        scrollToTop();
      });
    }

    prevPath.current = pathname;
  }, [pathname, scrollToTop]);

  return null;
};

export default ScrollToTop;